/**
 * DotLottie startup animation. File: `frontend/public/saae_preloader.lottie`.
 * Full-screen viewport preloader for broker / login flows.
 */

import { SaaePreloaderCore } from '@components/SaaePreloaderCore';
import { SAAE_PRELOADER_Z_INDEX_CLASS } from '@lib/saaePreloader';

const BAND_CLASS = 'flex w-full min-h-0 shrink-0 h-[50dvh] items-center justify-center';

export function GlobalPreloader() {
  return (
    <div
      className={`fixed inset-0 ${SAAE_PRELOADER_Z_INDEX_CLASS} bg-surface-web`}
      role="status"
      aria-busy="true"
      aria-live="polite"
    >
      <div className={`p-4 sm:p-6 ${BAND_CLASS}`}>
        <SaaePreloaderCore />
      </div>
    </div>
  );
}
